var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"campaign-base"},[_c('block-hero'),_vm._v(" "),_c('block-howto'),_vm._v(" "),_c('block-subsc-contents'),_vm._v(" "),_c('lp-footer',{attrs:{"color-scheme":_vm.colorScheme,"menu-list":_vm.footerMenuList,"showToTopBtn":false}}),_vm._v(" "),_c('friend-button',{class:[ _vm.showFriendBtn ? 'show' : '']})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38f6e47e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/utvStore/components/lp/campaign/LineCampaign202110/index.vue
// module id = null
// module chunks = 